import { Component, Host, h, Element, Prop } from '@stencil/core';

export interface AhaEmptyStateJumbo extends HTMLAhaEmptyStateJumboElement {}

/**
 * @slot media - Contents of the media container.
 * @slot headline - Contents of the headline.
 * @slot title - Contents of the title.
 * @slot body - Contents of the body.
 */
@Component({
  tag: 'aha-empty-state-jumbo',
  styleUrl: 'aha-empty-state-jumbo.css',
  shadow: true,
})
export class AhaEmptyStateJumbo {
  @Element() host!: HTMLAhaEmptyStateJumboElement;

  /**
   * Whether to render or not the media.
   */
  @Prop({ reflect: true, attribute: 'hide-media' }) hideMedia: boolean = false;

  /**
   * Whether to apply a box-shadow to the media-container
   */
  @Prop({ attribute: 'media-shadow' }) mediaShadow: boolean = true;

  render() {
    return (
      <Host class={this.mediaShadow ? 'media-shadow' : ''}>
        {!this.hideMedia && (
          <div id="media-container">
            <slot name="media"></slot>
          </div>
        )}
        <div>
          <slot name="headline"></slot>
          <slot name="title"></slot>
          <slot name="body"></slot>
        </div>
      </Host>
    );
  }
}
